import { checkIfContentEmpty } from "../../../../utils/tiptap";

export const submitValidation = (block: any) => {
  let errorHandler = {
    basic: "",
    ok: true,
  };

  const basicError = (message: string) => {
    errorHandler.ok = false;
    errorHandler.basic = message;
  };

  if (
    ["title", "subtitle", "input", "checkbox", "signature"].includes(block.type)
  ) {
    if (!block?.label?.trim()) {
      basicError("Fill all the required fields");
    }
  }
  if (block.type === "text") {
    if (checkIfContentEmpty(block?.label)) {
      basicError("Fill all the required fields");
    }
  }

  if (block.type === "picture") {
    if (!block?.resourceUrl?.trim()) {
      basicError("Please upload an image");
    }
  }
  if (block.type === "video") {
    if (!block?.resourceUrl?.trim()) {
      basicError("Please upload a video");
    }
  }
  //choice validation
  const choices = block?.config?.choices;

  if (choices && ["radio"].includes(block?.type)) {
    if (choices?.length < 2) {
      errorHandler = {
        basic: "Atleast two choices are required",
        ok: false,
      };
    } else {
      let key = false;
      let label = false;

      for (let i = 0; i < choices?.length; i++) {
        const choice = block?.config?.choices[i];

        if (!choice?.key) {
          key = true;
        }
        if (!choice?.label) {
          label = true;
        }
      }

      if (key || label) {
        errorHandler = {
          basic: "Choices need keys and labels",
          ok: false,
        };
      }
    }
  }

  return { errorHandler };
};

export const copyBlockMiddleware = (originalBlock: any) => {
  let newBlock = JSON.parse(JSON.stringify(originalBlock));

  // Remove unique attributes
  delete newBlock.id;

  // Increment position
  newBlock.position = originalBlock.position + 1;

  return newBlock;
};
